import { twMerge } from 'tailwind-merge';
import { ReactNode } from 'react';

export interface ShipmentMethodCardProps {
  title: string;
  description: string;
  price: string;
  icon?: ReactNode;
  selected?: boolean;
  recommended?: boolean;
  onClick?: () => void;
  disabled?: boolean;
  readOnly?: boolean;
}

export function ShipmentMethodCard({
  title,
  description,
  price,
  icon,
  selected = false,
  recommended = false,
  onClick,
  disabled = false,
  readOnly = false,
}: ShipmentMethodCardProps) {
  const Tag = readOnly ? 'div' : 'button';
  return (
    <Tag
      {...(!readOnly && { type: 'button' as const, onClick, disabled })}
      className={twMerge(
        'relative w-full rounded-lg border-2 p-4 text-left font-inter',
        readOnly
          ? 'border-gray-200 bg-white cursor-default'
          : 'transition-all duration-150',
        !readOnly && selected
          ? 'border-primary bg-blue-50'
          : !readOnly && 'border-gray-200 bg-white hover:border-gray-300',
        recommended && selected && !readOnly && 'border-primary bg-blue-50',
        recommended && !selected && !readOnly && 'border-blue-200 bg-blue-50/50',
        recommended && readOnly && 'border-blue-200 bg-blue-50/50',
        disabled && !readOnly && 'cursor-not-allowed opacity-50'
      )}
    >
      {recommended && (
        <span className='absolute -top-2.5 left-4 inline-flex items-center rounded-full bg-primary px-2 py-0.5 text-xs font-medium text-white'>
          Recommended
        </span>
      )}
      <div className='flex items-start gap-3'>
        {icon && (
          <div className='flex-shrink-0 mt-0.5 text-gray-400'>
            {icon}
          </div>
        )}
        <div className='flex-1 min-w-0'>
          <div className='flex items-center justify-between'>
            <h3 className='text-sm font-medium text-gray-900'>
              {title}
            </h3>
          </div>
          <p className='mt-0.5 text-xs text-gray-500 line-clamp-2'>
            {description}
          </p>
          <p className='mt-1 text-sm font-medium text-gray-900'>
            {price}
          </p>
        </div>
        {!readOnly && (
          <div className='flex-shrink-0'>
            <div
              className={twMerge(
                'h-5 w-5 rounded-full border-2 flex items-center justify-center',
                selected
                  ? 'border-primary bg-primary'
                  : 'border-gray-300 bg-white'
              )}
            >
              {selected && (
                <div className='h-2 w-2 rounded-full bg-white' />
              )}
            </div>
          </div>
        )}
      </div>
    </Tag>
  );
}
